const MAXIMUM_UPLOAD = 5;

export const getRemainingSpace = (length: number) => {
  return MAXIMUM_UPLOAD - (length || 0);
};
